let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7Rbde")).then(() => parcelRequire('awMdX'));